// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Before/after compare slider (ImageCompareSlider + modal) */
.compare-slider-container {
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  min-height: 400px;
  overflow: hidden;
  background-color: #f5f5f5;
  border-radius: 8px;
  cursor: pointer;
  user-select: none;
}

.compare-slider-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center center;
  user-select: none;
  pointer-events: none;
  min-width: 100%;
  min-height: 100%;
}

.compare-slider-foreground {
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  overflow: hidden;
  border-right: 3px solid #fff;
  box-sizing: border-box;
  z-index: 2;
}

.compare-slider-original {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  object-fit: contain;
  object-position: center center;
  user-select: none;
  pointer-events: none;
  min-height: 100%;
}

.compare-slider-handle {
  position: absolute;
  top: 0;
  left: 50%;
  width: 60px;
  height: 100%;
  cursor: col-resize;
  z-index: 10;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.compare-slider-handle-line {
  width: 4px;
  height: 100%;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  position: relative;
}

.compare-slider-handle-circle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #fff;
  border: 3px solid #000;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.4);
  cursor: col-resize;
}

.compare-slider-handle-icon {
  font-size: 20px;
  font-weight: bold;
  user-select: none;
}

.compare-stats {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
}

.compare-stat-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
}

/* Manual upload / batch table thumbnails — never expand to intrinsic image size */
.batch-thumb-cell {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 6px;
  overflow: hidden;
  background: var(--p-color-bg-subdued, #f6f6f7);
  display: flex;
  align-items: center;
  justify-content: center;
}

.batch-file-thumbnail {
  width: 40px;
  height: 40px;
  object-fit: cover;
  display: block;
  vertical-align: middle;
}

.batch-file-thumbnail-placeholder {
  font-size: 18px;
  line-height: 40px;
  text-align: center;
}

.batch-file-name-wrap {
  min-width: 0;
}

.batch-file-sub {
  display: block;
  margin-top: 2px;
}

/* Job image rows in OptimizationProgress accordion */
.job-image-row {
  padding: var(--p-space-300, 12px);
  border: 1px solid var(--p-color-border, #e1e3e5);
  border-radius: var(--p-border-radius-200, 8px);
  background: var(--p-color-bg, #ffffff);
  transition: background 0.15s ease;
}

.job-image-row--clickable {
  cursor: pointer;
}

.job-image-row--clickable:hover {
  background: var(--p-color-bg-surface-hover, #f6f6f7);
}

/* Progress Bar Styles */
.progress-bar-container {
  width: 100%;
  height: 24px;
  background-color: #e1e3e5;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  border: 1px solid #c9cccf;
}

.progress-bar-fill {
  height: 100%;
  background-color: var(--p-color-bg-success, #008060);
  transition: width 0.3s ease;
  border-radius: 4px;
  min-width: 0;
  position: relative;
  overflow: hidden;
}

.progress-bar-fill.progress-in-progress {
  background-color: var(--p-color-bg-warning, #f59e0b);
}

.progress-bar-fill.progress-completed {
  background-color: var(--p-color-bg-success, #008060);
}

.progress-bar-fill.progress-in-progress::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

/* Initial app loading state - full width */
.app-loading-section {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}
.app-loading-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.app-loading-shimmer {
  width: 100%;
  height: 200px;
  border-radius: 8px;
  margin-top: 0.5rem;
}

/* Skeleton / Shimmer Loader Styles */
.shimmer-loader {
  position: relative;
  overflow: hidden;
  background: linear-gradient(
    90deg,
    #e1e3e5 0%,
    #e1e3e5 40%,
    rgba(255, 255, 255, 0.6) 50%,
    #e1e3e5 60%,
    #e1e3e5 100%
  );
  background-size: 200% 100%;
  animation: shimmer-slide 1.5s ease-in-out infinite;
  border-radius: 4px;
}

@keyframes shimmer-slide {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.shimmer-text-small {
  height: 11px;
  width: 60px;
}

.shimmer-text-medium {
  height: 14px;
  width: 80px;
}

.shimmer-heading {
  height: 32px;
  width: 100px;
}

/* Credits Widget: no custom CSS needed — uses Shopify s-* components */

/* Info tooltip (ⓘ icon with hover bubble) */

/* Sticky Layout Classes */
.sticky-header {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: var(--p-color-bg-surface, #ffffff);
  padding-bottom: 8px;
}

.sticky-footer {
  position: sticky;
  bottom: 0;
  z-index: 10;
  background-color: var(--p-color-bg-surface, #ffffff);
  padding-top: 16px;
  padding-bottom: 8px;
  border-top: 1px solid var(--p-color-border-subdued, #e1e3e5);
}

/* Product Row Styles */
.product-thumbnail-container {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--p-color-bg-subdued, #f6f6f7);
}

.product-thumbnail-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-thumbnail-fallback {
  font-size: 20px;
}

/* Image Management Table Styles */
.image-management-table {
  border: 1px solid var(--p-color-border, #e3e3e3);
  border-radius: 8px;
  overflow: hidden;
}

.image-management-header {
  display: grid;
  grid-template-columns: auto auto 1fr auto;
  gap: 16px;
  padding: 8px 12px;
  background: var(--p-color-bg-surface-secondary, #f7f7f7);
  border-bottom: 1px solid var(--p-color-border, #e3e3e3);
  align-items: center;
}

.image-management-product-row {
  border-bottom: 1px solid var(--p-color-border, #e3e3e3);
}

.clickable-row {
  cursor: pointer;
  padding: 8px 16px;
  transition: background-color 0.1s;
}

.clickable-row:hover {
  background-color: var(--p-color-bg-surface-hover, #f1f1f1);
}

.image-management-nested-images {
  padding: 4px 16px 12px 48px;
  margin: 0;
  border-left: none;
  background: var(--p-color-bg-surface-secondary, #fafafa);
  border-top: 1px solid var(--p-color-border-subdued, #e1e3e5);
}

/* ProductSelection flat list (no accordion) */
.ps-product-list-header {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 16px;
  padding: 10px 16px;
  border-bottom: 1px solid var(--p-color-border, #e3e3e3);
  background: var(--p-color-bg-surface-secondary, #f7f7f7);
}

.ps-product-list-row {
  display: grid;
  grid-template-columns: auto auto 1fr auto;
  gap: 12px;
  align-items: center;
  padding: 10px 16px;
}

.ps-product-title {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ps-remaining-count {
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
  color: var(--p-color-text-secondary, #616161);
}

/* ImageRow inside nested images — plain div for predictable bg */
.image-row-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  border-top: 1px solid var(--p-color-border-subdued, #e1e3e5);
  background: transparent;
  cursor: pointer;
  transition: background-color 0.1s;
}

.image-row-item:hover {
  background-color: rgba(0, 0, 0, 0.03);
}

.image-row-item:first-child {
  border-top: none;
}

/* Manual Upload Styles */
.mu-session-expanded-content {
  padding: 8px 16px 12px 16px;
  margin: 0;
  border-left: none;
  background: transparent;
}

.mu-file-card {
  padding: 8px 12px;
  background: var(--p-color-bg-surface, #ffffff);
  border-radius: 8px;
  border: 1px solid var(--p-color-border, #e3e3e3);
}

.mu-drop-zone-container {
  padding: 56px 24px;
  text-align: center;
  cursor: pointer;
  user-select: none;
  border-radius: 7px;
  background-color: var(--p-surface-subdued, #FAFBFB);
  border: 2px dashed transparent;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.mu-drop-zone-container.drag-over {
  background-color: var(--p-surface-selected, #F2F7FE);
  border-color: var(--p-border-interactive, #2C6ECB);
}

/* Pricing Page Styles */
.pricing-page-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 0 48px;
}

.pricing-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  margin-top: 24px;
}

.pricing-card {
  border-radius: 12px;
  padding: 28px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 0;
  position: relative;
  transition: box-shadow 0.15s;
  background: var(--p-color-bg-surface, #fff);
  border: 1px solid var(--p-color-border, #e3e3e3);
}

.pricing-card-highlight {
  border: 2px solid #2c6ecb;
  background: #f0f6ff;
}

.pricing-popular-badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: #2c6ecb;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.05em;
  padding: 3px 12px;
  border-radius: 20px;
  white-space: nowrap;
}

.pricing-card-icon {
  font-size: 32px;
  margin-bottom: 8px;
}

.pricing-card-title {
  font-size: 20px;
  font-weight: 700;
  color: var(--p-color-text, #202223);
  margin-bottom: 2px;
}

.pricing-card-credits {
  font-size: 15px;
  color: var(--p-color-text-subdued, #616161);
  margin-bottom: 16px;
}

.pricing-card-price {
  font-size: 32px;
  font-weight: 800;
  color: var(--p-color-text, #202223);
  letter-spacing: -0.02em;
  margin-bottom: 4px;
}

.pricing-card-price-note {
  font-size: 12px;
  color: var(--p-color-text-subdued, #616161);
  margin-bottom: 20px;
}

.pricing-card-divider {
  border-top: 1px solid var(--p-color-border, #e3e3e3);
  margin: 16px 0;
}

.pricing-feature-list {
  list-style: none;
  padding: 0;
  margin: 0 0 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pricing-feature-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 13px;
  color: var(--p-color-text, #202223);
}

.pricing-checkmark {
  color: #36a420;
  font-size: 14px;
  flex-shrink: 0;
  margin-top: 1px;
}

.pricing-purchase-button {
  width: 100%;
  padding: 10px 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.15s;
  margin-top: auto;
  border: 1px solid var(--p-color-border, #ccc);
  background: transparent;
  color: #202223;
}

.pricing-purchase-button:disabled {
  background: #e9ecef;
  color: #999;
  cursor: default;
}

.pricing-purchase-button-highlight {
  background: #2c6ecb;
  color: #fff;
  border: none;
}

.pricing-balance-box {
  background: var(--p-color-bg-surface-secondary, #f6f6f7);
  border: 1px solid var(--p-color-border, #e3e3e3);
  border-radius: 10px;
  padding: 20px 24px;
  margin-bottom: 32px;
}

.pricing-fine-print {
  margin-top: 32px;
  font-size: 12px;
  color: var(--p-color-text-subdued, #616161);
  text-align: center;
}

/* Public Compare Styles */
.public-compare-container {
  width: 100vw;
  height: 100vh;
  background-color: var(--p-color-bg-surface-secondary, #F6F6F7);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

.public-compare-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: var(--p-color-bg-surface, #FFFFFF);
  border-bottom: 1px solid var(--p-color-border-subdued, #E1E3E5);
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.05);
}

.public-compare-body {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 16px 16px 16px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.public-compare-slider-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.h-100vh {
  height: 100vh;
}

/* Public JSON Optimization Styles */
.public-json-img-preview {
  flex-shrink: 0;
  max-width: 150px;
  max-height: 150px;
  width: auto;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
  display: block;
}

.public-json-slider-container {
  margin-top: 16px;
}

/* Tab Bar Styles */
.tab-bar-container {
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--p-color-border, #e3e3e3);
  background: var(--p-color-bg-surface, #fff);
  border-radius: 8px 8px 0 0;
}

.tab-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 20px;
  cursor: pointer;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  font-weight: 400;
  font-size: 14px;
  color: var(--p-color-text-secondary, #616161);
  margin-bottom: -1px;
  user-select: none;
  transition: color 0.1s, border-bottom-color 0.1s;
}

.tab-button-active {
  border-bottom-color: var(--p-color-border-interactive, #005bd3);
  font-weight: 600;
  color: var(--p-color-text, #1a1a1a);
}

.tab-container-flex {
  display: flex;
  flex: 1;
  align-items: center;
  min-width: 0;
}

.tab-bar-action {
  margin-left: auto;
  padding: 0 8px;
  flex-shrink: 0;
}

.sub-tab-button {
  flex: 1;
  justify-content: center;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  cursor: pointer;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  font-weight: 400;
  font-size: 13px;
  color: var(--p-color-text-secondary, #616161);
  margin-bottom: -1px;
  user-select: none;
}

.sub-tab-button-active {
  background: var(--p-color-bg-surface-secondary, #f7f7f7);
  border-bottom-color: var(--p-color-border-interactive, #005bd3);
  font-weight: 600;
  color: var(--p-color-text, #1a1a1a);
}

/* Batch Card Styles */
.batch-card {
  border: 1px solid var(--p-color-border, #e3e3e3);
  border-left-width: 4px;
  border-left-style: solid;
  border-radius: 8px;
  overflow: hidden;
  background: var(--p-color-bg-surface, #fff);
}

.batch-card-success { border-left-color: var(--p-color-border-success, #1a7f5a); }
.batch-card-critical { border-left-color: var(--p-color-border-critical, #d72c0d); }
.batch-card-info { border-left-color: var(--p-color-border-info, #007ace); }

.batch-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px; /* Changed padding to match standard spacing */
  cursor: pointer;
  user-select: none;
  transition: background 0.15s ease;
}

.batch-header:hover { background: var(--p-color-bg-surface-secondary, #f7f7f7); }

.batch-table-row {
  display: grid;
  gap: 8px;
  padding: 10px 12px;
  border-bottom: 1px solid var(--p-color-border, #e3e3e3);
  align-items: center;
  background: var(--p-color-bg-surface, #fff);
}

.batch-table-row:last-child { border-bottom: none; }

.batch-table-header {
  display: grid;
  gap: 8px;
  padding: 8px 12px;
  background: var(--p-color-bg-surface-secondary, #f7f7f7);
  border-bottom: 1px solid var(--p-color-border, #e3e3e3);
  align-items: center;
}

/* Utility Classes */
.w-100 { width: 100%; }
.max-w-400 { max-width: 400px; }
.flex-center { display: flex; align-items: center; justify-content: center; }
.h-100vh { height: 100vh; }
.tab-container { display: flex; flex: 1; }
.tab-new-button-container { padding-right: 10px; }

/* Old styles that might be unused now, but kept for now */
/* List-structure skeleton for listing pages */
.list-skeleton-wrapper {
  width: 100%;
}
.list-skeleton-row {
  background: var(--p-color-bg-surface, #fff);
}

/* Skeleton / Shimmer Loader Styles */
.shimmer-loader {
  position: relative;
  overflow: hidden;
  background: linear-gradient(
    90deg,
    #e1e3e5 0%,
    #e1e3e5 40%,
    rgba(255, 255, 255, 0.6) 50%,
    #e1e3e5 60%,
    #e1e3e5 100%
  );
  background-size: 200% 100%;
  animation: shimmer-slide 1.5s ease-in-out infinite;
  border-radius: 4px;
}

@keyframes shimmer-slide {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.shimmer-text-small { height: 11px; width: 60px; }
.shimmer-text-medium { height: 14px; width: 80px; }
.shimmer-heading { height: 32px; width: 100px; }
.shimmer-rounded { border-radius: 4px; } /* Added for rounded shimmers */

/* Spacing utilities */
.gap-small-100 { gap: 0.5rem; }
.gap-small-200 { gap: 0.75rem; }
.gap-base { gap: 1rem; }
.gap-large { gap: 1.5rem; }

/* Specific component styling, moved from inline styles */
.product-thumbnail-container {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--p-color-bg-subdued, #f6f6f7);
}
.product-thumbnail-img {
  width: 100%; height: 100%; object-fit: cover;
}
.product-thumbnail-fallback { font-size: 20px; }

.mu-drop-zone-container {
  padding: 56px 24px; text-align: center; cursor: pointer; user-select: none;
  border-radius: 7px; background-color: var(--p-surface-subdued, #FAFBFB);
  border: 2px dashed transparent; transition: background-color 0.15s ease, border-color 0.15s ease;
}
.mu-drop-zone-container.drag-over {
  background-color: var(--p-surface-selected, #F2F7FE);
  border-color: var(--p-border-interactive, #2C6ECB);
}
.mu-session-expanded-content {
  padding-left: 56px; padding-right: 16px; border-left: 3px solid var(--p-color-border-info, #007ace);
  margin-left: 16px; background: var(--p-color-bg-subdued, #f6f6f7);
}
.mu-file-card {
  padding: 8px 12px; background: var(--p-color-bg-surface, #fff); border-radius: 8px;
  border: 1px solid var(--p-color-border, #e3e3e3);
}
.mu-spinner {
  width: 32px; height: 32px; border: 3px solid rgba(0,0,0,0.1); border-top-color: var(--p-color-border-interactive, #005bd3); border-radius: 50%;
  animation: spin 1s linear infinite;
}

.pricing-page-container { max-width: 900px; margin: 0 auto; padding: 0 0 48px; }
.pricing-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 20px; margin-top: 24px; }
.pricing-card {
  border-radius: 12px; padding: 28px 24px 24px; display: flex; flex-direction: column; gap: 0; position: relative;
  transition: box-shadow 0.15s; background: var(--p-color-bg-surface, #fff); border: 1px solid var(--p-color-border, #e3e3e3);
}
.pricing-card-highlight { border: 2px solid #2c6ecb; background: #f0f6ff; }
.pricing-popular-badge {
  position: absolute; top: -12px; left: 50%; transform: translateX(-50%);
  background: #2c6ecb; color: #fff; font-size: 11px; font-weight: 700; letter-spacing: 0.05em;
  padding: 3px 12px; border-radius: 20px; white-space: nowrap;
}
.pricing-card-icon { font-size: 32px; margin-bottom: 8px; }
.pricing-card-title { font-size: 20px; font-weight: 700; color: var(--p-color-text, #202223); margin-bottom: 2px; }
.pricing-card-credits { font-size: 15px; color: var(--p-color-text-subdued, #616161); margin-bottom: 16px; }
.pricing-card-price { font-size: 32px; font-weight: 800; color: var(--p-color-text, #202223); letter-spacing: -0.02em; margin-bottom: 4px; }
.pricing-card-price-note { font-size: 12px; color: var(--p-color-text-subdued, #616161); margin-bottom: 20px; }
.pricing-card-divider { border-top: 1px solid var(--p-color-border, #e3e3e3); margin: 16px 0; }
.pricing-feature-list { list-style: none; padding: 0; margin: 0 0 24px; display: flex; flex-direction: column; gap: 8px; }
.pricing-feature-item { display: flex; align-items: flex-start; gap: 8px; font-size: 13px; color: var(--p-color-text, #202223); }
.pricing-checkmark { color: #36a420; font-size: 14px; flex-shrink: 0; margin-top: 1px; }
.pricing-purchase-button {
  width: 100%; padding: 10px 16px; border-radius: 8px; font-weight: 600; font-size: 14px; cursor: pointer; transition: background 0.15s;
  margin-top: auto; border: 1px solid var(--p-color-border, #ccc); background: transparent; color: #202223;
}
.pricing-purchase-button:disabled { background: #e9ecef; color: #999; cursor: default; }
.pricing-purchase-button-highlight { background: #2c6ecb; color: #fff; border: none; }
.pricing-balance-box {
  background: var(--p-color-bg-surface-secondary, #f6f6f7); border: 1px solid var(--p-color-border, #e3e3e3); border-radius: 10px;
  padding: 20px 24px; margin-bottom: 32px;
}
.pricing-fine-print { margin-top: 32px; font-size: 12px; color: var(--p-color-text-subdued, #616161); text-align: center; }

/* Public Compare Styles */
.public-compare-container {
  width: 100vw; height: 100vh; background-color: var(--p-color-bg-surface-secondary, #F6F6F7);
  display: flex; flex-direction: column; overflow: hidden; position: relative;
}
.public-compare-header {
  position: absolute; top: 0; left: 0; right: 0; z-index: 100;
  background-color: var(--p-color-bg-surface, #FFFFFF); border-bottom: 1px solid var(--p-color-border-subdued, #E1E3E5);
  padding: 16px; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 16px;
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.05);
}
.public-compare-body {
  flex: 1; display: flex; align-items: center; justify-content: center;
  padding: 80px 16px 16px 16px; width: 100%; height: 100%; box-sizing: border-box;
}
.public-compare-slider-wrapper {
  width: 100%; height: 100%; position: relative;
}

/* Public JSON Optimization Styles */
.public-json-img-preview {
  flex-shrink: 0; max-width: 150px; max-height: 150px; width: auto; height: auto;
  object-fit: cover; border-radius: 8px; display: block;
}
.public-json-slider-container { margin-top: 16px; }

/* Tab Bar Styles */
.tab-bar-container { display: flex; align-items: center; border-bottom: 1px solid var(--p-color-border, #e3e3e3); background: var(--p-color-bg-surface, #fff); border-radius: 8px 8px 0 0; }
.tab-button {
  display: flex; align-items: center; gap: 6px; padding: 12px 20px; cursor: pointer; background: none; border: none;
  border-bottom: 2px solid transparent; font-weight: 400; font-size: 14px; color: var(--p-color-text-secondary, #616161);
  margin-bottom: -1px; user-select: none; transition: color 0.1s, border-bottom-color 0.1s;
}
.tab-button-active { border-bottom-color: var(--p-color-border-interactive, #005bd3); font-weight: 600; color: var(--p-color-text, #1a1a1a); }
.sub-tab-button {
  flex: 1; justify-content: center; display: flex; align-items: center; gap: 6px; padding: 10px 16px; cursor: pointer; background: none; border: none;
  border-bottom: 2px solid transparent; font-weight: 400; font-size: 13px; color: var(--p-color-text-secondary, #616161);
  margin-bottom: -1px; user-select: none;
}
.sub-tab-button-active {
  background: var(--p-color-bg-surface-secondary, #f7f7f7); border-bottom-color: var(--p-color-border-interactive, #005bd3);
  font-weight: 600; color: var(--p-color-text, #1a1a1a);
}

/* Batch Card Styles */
.batch-card {
  border: 1px solid var(--p-color-border, #e3e3e3); border-left-width: 4px; border-left-style: solid;
  border-radius: 8px; overflow: hidden; background: var(--p-color-bg-surface, #fff);
}
.batch-card-success { border-left-color: var(--p-color-border-success, #1a7f5a); }
.batch-card-critical { border-left-color: var(--p-color-border-critical, #d72c0d); }
.batch-card-info { border-left-color: var(--p-color-border-info, #007ace); }
.batch-header,
.batch-card-header {
  display: flex; align-items: center; justify-content: space-between; gap: 12px;
  padding: 8px 12px; cursor: pointer; user-select: none; transition: background 0.15s ease;
}
.batch-header:hover,
.batch-card-header:hover { background: var(--p-color-bg-surface-secondary, #f7f7f7); }
.batch-table-row {
  display: grid; gap: 8px; padding: 10px 12px; border-bottom: 1px solid var(--p-color-border, #e3e3e3);
  align-items: center; background: var(--p-color-bg-surface, #fff);
}
.batch-table-row:last-child { border-bottom: none; }
.batch-table-header {
  display: grid; gap: 8px; padding: 8px 12px; background: var(--p-color-bg-surface-secondary, #f7f7f7);
  border-bottom: 1px solid var(--p-color-border, #e3e3e3); align-items: center;
}

.mu-status-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.3;
}
.mu-status-done { background: #e3f1df; color: #0b7b5e; }
.mu-status-compressing { background: #e8f2ff; color: #005bd3; }
.mu-status-waiting { background: #f3f2ef; color: #6d7175; }
.mu-status-processing { background: #e8f2ff; color: #005bd3; }
.mu-status-pending { background: #f3f2ef; color: #6d7175; }
.mu-status-failed { background: #fde2dd; color: #b42318; }
.mu-status-skipped { background: #fff1dc; color: #8a6116; }

.batch-actions {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
}

.batch-action-btn {
  white-space: nowrap;
}

.mu-session-summary-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  padding: 10px 12px;
  border-top: none;
  margin-bottom: 8px;
  background: var(--p-color-bg-surface-secondary, #f7f7f7);
}

.mu-session-summary-card {
  background: var(--p-color-bg-surface, #fff);
  border: 1px solid var(--p-color-border-subdued, #e1e3e5);
  border-radius: 8px;
  padding: 8px 10px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/* Utility Classes */
.w-100 { width: 100%; }
.max-w-400 { max-width: 400px; }
.flex-center { display: flex; align-items: center; justify-content: center; }
.h-100vh { height: 100vh; }
.tab-container { display: flex; flex: 1; }
.tab-new-button-container { padding-right: 10px; }

/* Skeleton / Shimmer Loader Styles */
.shimmer-loader {
  position: relative;
  overflow: hidden;
  background: linear-gradient(
    90deg,
    #e1e3e5 0%,
    #e1e3e5 40%,
    rgba(255, 255, 255, 0.6) 50%,
    #e1e3e5 60%,
    #e1e3e5 100%
  );
  background-size: 200% 100%;
  animation: shimmer-slide 1.5s ease-in-out infinite;
  border-radius: 4px;
}
.shimmer-rounded { border-radius: 4px; } /* For rounded shimmers */
@keyframes shimmer-slide { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }

/* Spacing utilities */
.gap-small-100 { gap: 0.5rem; }
.gap-small-200 { gap: 0.75rem; }
.gap-base { gap: 1rem; }
.gap-large { gap: 1.5rem; }

/* Specific component styling, moved from inline styles */
.product-thumbnail-container { display: flex; align-items: center; justify-content: center; background-color: var(--p-color-bg-subdued, #f6f6f7); }
.product-thumbnail-img { width: 100%; height: 100%; object-fit: cover; }
.product-thumbnail-fallback { font-size: 20px; }
.mu-drop-zone-container { padding: 56px 24px; text-align: center; cursor: pointer; user-select: none; border-radius: 7px; background-color: var(--p-surface-subdued, #FAFBFB); border: 2px dashed transparent; transition: background-color 0.15s ease, border-color 0.15s ease; }
.mu-drop-zone-container.drag-over { background-color: var(--p-surface-selected, #F2F7FE); border-color: var(--p-border-interactive, #2C6ECB); }
.mu-session-expanded-content { padding-left: 56px; padding-right: 16px; border-left: 3px solid var(--p-color-border-info, #007ace); margin-left: 16px; background: var(--p-color-bg-subdued, #f6f6f7); }
.mu-file-card { padding: 8px 12px; background: var(--p-color-bg-surface, #fff); border-radius: 8px; border: 1px solid var(--p-color-border, #e3e3e3); }
.mu-spinner { width: 32px; height: 32px; border: 3px solid rgba(0,0,0,0.1); border-top-color: var(--p-color-border-interactive, #005bd3); border-radius: 50%; animation: spin 1s linear infinite; }
@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }

/* Pricing Page Styles */
.pricing-page-container { max-width: 900px; margin: 0 auto; padding: 0 0 48px; }
.pricing-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 20px; margin-top: 24px; }
.pricing-card {
  border-radius: 12px; padding: 28px 24px 24px; display: flex; flex-direction: column; gap: 0; position: relative;
  transition: box-shadow 0.15s; background: var(--p-color-bg-surface, #fff); border: 1px solid var(--p-color-border, #e3e3e3);
}
.pricing-card-highlight { border: 2px solid #2c6ecb; background: #f0f6ff; }
.pricing-popular-badge {
  position: absolute; top: -12px; left: 50%; transform: translateX(-50%);
  background: #2c6ecb; color: #fff; font-size: 11px; font-weight: 700; letter-spacing: 0.05em;
  padding: 3px 12px; border-radius: 20px; white-space: nowrap;
}
.pricing-card-icon { font-size: 32px; margin-bottom: 8px; }
.pricing-card-title { font-size: 20px; font-weight: 700; color: var(--p-color-text, #202223); margin-bottom: 2px; }
.pricing-card-credits { font-size: 15px; color: var(--p-color-text-subdued, #616161); margin-bottom: 16px; }
.pricing-card-price { font-size: 32px; font-weight: 800; color: var(--p-color-text, #202223); letter-spacing: -0.02em; margin-bottom: 4px; }
.pricing-card-price-note { font-size: 12px; color: var(--p-color-text-subdued, #616161); margin-bottom: 20px; }
.pricing-card-divider { border-top: 1px solid var(--p-color-border, #e3e3e3); margin: 16px 0; }
.pricing-feature-list { list-style: none; padding: 0; margin: 0 0 24px; display: flex; flex-direction: column; gap: 8px; }
.pricing-feature-item { display: flex; align-items: flex-start; gap: 8px; font-size: 13px; color: var(--p-color-text, #202223); }
.pricing-checkmark { color: #36a420; font-size: 14px; flex-shrink: 0; margin-top: 1px; }
.pricing-purchase-button {
  width: 100%; padding: 10px 16px; border-radius: 8px; font-weight: 600; font-size: 14px; cursor: pointer; transition: background 0.15s;
  margin-top: auto; border: 1px solid var(--p-color-border, #ccc); background: transparent; color: #202223;
}
.pricing-purchase-button:disabled { background: #e9ecef; color: #999; cursor: default; }
.pricing-purchase-button-highlight { background: #2c6ecb; color: #fff; border: none; }
.pricing-balance-box {
  background: var(--p-color-bg-surface-secondary, #f6f6f7); border: 1px solid var(--p-color-border, #e3e3e3); border-radius: 10px;
  padding: 20px 24px; margin-bottom: 32px;
}
.pricing-fine-print { margin-top: 32px; font-size: 12px; color: var(--p-color-text-subdued, #616161); text-align: center; }

/* Public Compare Styles */
.public-compare-container {
  width: 100vw; height: 100vh; background-color: var(--p-color-bg-surface-secondary, #F6F6F7);
  display: flex; flex-direction: column; overflow: hidden; position: relative;
}
.public-compare-header {
  position: absolute; top: 0; left: 0; right: 0; z-index: 100;
  background-color: var(--p-color-bg-surface, #FFFFFF); border-bottom: 1px solid var(--p-color-border-subdued, #E1E3E5);
  padding: 16px; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 16px;
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.05);
}
.public-compare-body {
  flex: 1; display: flex; align-items: center; justify-content: center;
  padding: 80px 16px 16px 16px; width: 100%; height: 100%; box-sizing: border-box;
}
.public-compare-slider-wrapper {
  width: 100%; height: 100%; position: relative;
}

/* Public JSON Optimization Styles */
.public-json-img-preview {
  flex-shrink: 0; max-width: 150px; max-height: 150px; width: auto; height: auto;
  object-fit: cover; border-radius: 8px; display: block;
}
.public-json-slider-container { margin-top: 16px; }

/* Tab Bar Styles */
.tab-bar-container { display: flex; align-items: center; border-bottom: 1px solid var(--p-color-border, #e3e3e3); background: var(--p-color-bg-surface, #fff); border-radius: 8px 8px 0 0; }
.tab-button {
  display: flex; align-items: center; gap: 6px; padding: 12px 20px; cursor: pointer; background: none; border: none;
  border-bottom: 2px solid transparent; font-weight: 400; font-size: 14px; color: var(--p-color-text-secondary, #616161);
  margin-bottom: -1px; user-select: none; transition: color 0.1s, border-bottom-color 0.1s;
}
.tab-button-active { border-bottom-color: var(--p-color-border-interactive, #005bd3); font-weight: 600; color: var(--p-color-text, #1a1a1a); }
.sub-tab-button {
  flex: 1; justify-content: center; display: flex; align-items: center; gap: 6px; padding: 10px 16px; cursor: pointer; background: none; border: none;
  border-bottom: 2px solid transparent; font-weight: 400; font-size: 13px; color: var(--p-color-text-secondary, #616161);
  margin-bottom: -1px; user-select: none;
}
.sub-tab-button-active {
  background: var(--p-color-bg-surface-secondary, #f7f7f7); border-bottom-color: var(--p-color-border-interactive, #005bd3);
  font-weight: 600; color: var(--p-color-text, #1a1a1a);
}

/* Batch Card Styles */
.batch-card {
  border: 1px solid var(--p-color-border, #e3e3e3); border-left-width: 4px; border-left-style: solid;
  border-radius: 8px; overflow: hidden; background: var(--p-color-bg-surface, #fff);
}
.batch-card-success { border-left-color: var(--p-color-border-success, #1a7f5a); }
.batch-card-critical { border-left-color: var(--p-color-border-critical, #d72c0d); }
.batch-card-info { border-left-color: var(--p-color-border-info, #007ace); }
.batch-header {
  display: flex; align-items: center; justify-content: space-between; gap: 12px;
  padding: 8px 12px; cursor: pointer; user-select: none; transition: background 0.15s ease;
}
.batch-header:hover { background: var(--p-color-bg-surface-secondary, #f7f7f7); }
.batch-table-row {
  display: grid; gap: 8px; padding: 10px 12px; border-bottom: 1px solid var(--p-color-border, #e3e3e3);
  align-items: center; background: var(--p-color-bg-surface, #fff);
}
.batch-table-row:last-child { border-bottom: none; }
.batch-table-header {
  display: grid; gap: 8px; padding: 8px 12px; background: var(--p-color-bg-surface-secondary, #f7f7f7);
  border-bottom: 1px solid var(--p-color-border, #e3e3e3); align-items: center;
}

/* Empty State */
.empty-state-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  gap: 8px;
}
.empty-state-message {
  max-width: 420px;
  margin-top: 4px;
}
.empty-state-action {
  margin-top: 12px;
}
/* EmptyState shared component icon */
.es-icon {
  font-size: 52px;
  line-height: 1;
  margin-bottom: 4px;
  filter: grayscale(0.1);
}

/* Utility Classes */
.w-100 { width: 100%; }
.max-w-400 { max-width: 400px; }
.flex-center { display: flex; align-items: center; justify-content: center; }
.h-100vh { height: 100vh; }
.tab-container { display: flex; flex: 1; }
.tab-new-button-container { padding-right: 10px; }

/* Old styles that might be unused now, but kept for now */
/* List-structure skeleton for listing pages */
.list-skeleton-wrapper {
  width: 100%;
}
.list-skeleton-row {
  background: var(--p-color-bg-surface, #fff);
}

/* Skeleton / Shimmer Loader Styles */
.shimmer-loader {
  position: relative;
  overflow: hidden;
  background: linear-gradient(
    90deg,
    #e1e3e5 0%,
    #e1e3e5 40%,
    rgba(255, 255, 255, 0.6) 50%,
    #e1e3e5 60%,
    #e1e3e5 100%
  );
  background-size: 200% 100%;
  animation: shimmer-slide 1.5s ease-in-out infinite;
  border-radius: 4px;
}
.shimmer-rounded { border-radius: 4px; } /* For rounded shimmers */
@keyframes shimmer-slide { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }

/* Spacing utilities */
.gap-small-100 { gap: 0.5rem; }
.gap-small-200 { gap: 0.75rem; }
.gap-base { gap: 1rem; }
.gap-large { gap: 1.5rem; }

/* ── Info tooltip (hover bubble next to “i”) ───────────────────────────────── */
.info-tooltip {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: help;
  max-width: 100%;
}

.info-tooltip-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #8c9196;
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  font-style: normal;
  line-height: 1;
  user-select: none;
  flex-shrink: 0;
}

.info-tooltip-bubble {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  background-color: #202223;
  color: #ffffff;
  font-size: 12px;
  line-height: 1.4;
  padding: 8px 12px;
  border-radius: 6px;
  white-space: normal;
  width: max-content;
  max-width: 280px;
  min-width: 80px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  pointer-events: none;
  transition: opacity 0.2s ease, visibility 0.2s ease, transform 0.2s ease;
}

.info-tooltip-bubble::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-top-color: #202223;
}

.info-tooltip:hover .info-tooltip-bubble,
.info-tooltip:focus-within .info-tooltip-bubble {
  visibility: visible;
  opacity: 1;
  transform: translateX(-50%) translateY(-2px);
}

/* ── Job activity feed ──────────────────────────────────────────────────────── */
.job-activity-feed {
  max-height: 320px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.job-activity-feed-header {
  padding: 8px 12px;
  border-bottom: 1px solid var(--p-color-border-subdued, #e1e3e5);
  flex-shrink: 0;
}

.job-activity-feed-scroll {
  overflow-y: auto;
  padding: 12px;
  flex: 1;
}

/* ── Job activity thumbnail ─────────────────────────────────────────────────── */
.job-item-thumbnail {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  flex-shrink: 0;
}

/* ── Progress bar cancelled state ───────────────────────────────────────────── */
.progress-bar-fill.progress-cancelled {
  background-color: #d82c0d;
}

/* ── Shimmer sizes ──────────────────────────────────────────────────────────── */
.shimmer-loader-tall { height: 200px; }
`, "",{"version":3,"sources":["webpack://./src/app.css"],"names":[],"mappings":"AAAA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,kFAAkF;AAClF;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;EAC9C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,qDAAqD;AACrD;EACE,iCAAiC;EACjC,gDAAgD;EAChD,8CAA8C;EAC9C,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oDAAoD;AACtD;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,sFAAsF;EACtF,8BAA8B;AAChC;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA,2CAA2C;AAC3C;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,gBAAgB;EAChB;;;;;;;GAOC;EACD,0BAA0B;EAC1B,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,uEAAuE;;AAEvE,4CAA4C;;AAE5C,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,oDAAoD;EACpD,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,oDAAoD;EACpD,iBAAiB;EACjB,mBAAmB;EACnB,4DAA4D;AAC9D;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,SAAS;EACT,iBAAiB;EACjB,wDAAwD;EACxD,uDAAuD;EACvD,mBAAmB;AACrB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,2BAA2B;EAC3B,SAAS;EACT,iBAAiB;EACjB,wDAAwD;EACxD,4DAA4D;AAC9D;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;EAClB,uDAAuD;EACvD,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4DAA4D;EAC5D,uBAAuB;EACvB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,2BAA2B;EAC3B,SAAS;EACT,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,8CAA8C;EAC9C,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mDAAmD;EACnD,8BAA8B;EAC9B,gEAAgE;AAClE;;AAEA;EACE,oDAAoD;EACpD,kDAAkD;AACpD;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,kBAAkB;EAClB,4BAA4B;EAC5B,2CAA2C;EAC3C,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,oDAAoD;EACpD,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,6CAA6C;EAC7C,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wDAAwD;EACxD,gDAAgD;EAChD,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,YAAY;EACZ,aAAa;EACb,8DAA8D;EAC9D,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,oDAAoD;EACpD,+DAA+D;EAC/D,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA,oCAAoC;AACpC;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,uDAAuD;EACvD,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,6CAA6C;EAC7C,mBAAmB;EACnB,iBAAiB;EACjB,gDAAgD;AAClD;;AAEA;EACE,+DAA+D;EAC/D,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,6CAA6C;EAC7C,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,wDAAwD;EACxD,+DAA+D;EAC/D,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA,sBAAsB;AACtB;EACE,gDAAgD;EAChD,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA,sBAAsB,yDAAyD,EAAE;AACjF,uBAAuB,0DAA0D,EAAE;AACnF,mBAAmB,sDAAsD,EAAE;;AAE3E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB,EAAE,8CAA8C;EACjE,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA,sBAAsB,wDAAwD,EAAE;;AAEhF;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,uDAAuD;EACvD,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA,8BAA8B,mBAAmB,EAAE;;AAEnD;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,wDAAwD;EACxD,uDAAuD;EACvD,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB,SAAS,WAAW,EAAE;AACtB,aAAa,gBAAgB,EAAE;AAC/B,eAAe,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;AAC5E,WAAW,aAAa,EAAE;AAC1B,iBAAiB,aAAa,EAAE,OAAO,EAAE;AACzC,4BAA4B,mBAAmB,EAAE;;AAEjD,0DAA0D;AAC1D,8CAA8C;AAC9C;EACE,WAAW;AACb;AACA;EACE,2CAA2C;AAC7C;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,gBAAgB;EAChB;;;;;;;GAOC;EACD,0BAA0B;EAC1B,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,sBAAsB,YAAY,EAAE,WAAW,EAAE;AACjD,uBAAuB,YAAY,EAAE,WAAW,EAAE;AAClD,mBAAmB,YAAY,EAAE,YAAY,EAAE;AAC/C,mBAAmB,kBAAkB,EAAE,EAAE,+BAA+B;;AAExE,sBAAsB;AACtB,iBAAiB,WAAW,EAAE;AAC9B,iBAAiB,YAAY,EAAE;AAC/B,YAAY,SAAS,EAAE;AACvB,aAAa,WAAW,EAAE;;AAE1B,yDAAyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oDAAoD;AACtD;AACA;EACE,WAAW,EAAE,YAAY,EAAE,iBAAiB;AAC9C;AACA,8BAA8B,eAAe,EAAE;;AAE/C;EACE,kBAAkB,EAAE,kBAAkB,EAAE,eAAe,EAAE,iBAAiB;EAC1E,kBAAkB,EAAE,mDAAmD;EACvE,8BAA8B,EAAE,gEAAgE;AAClG;AACA;EACE,oDAAoD;EACpD,kDAAkD;AACpD;AACA;EACE,kBAAkB,EAAE,mBAAmB,EAAE,0DAA0D;EACnG,iBAAiB,EAAE,8CAA8C;AACnE;AACA;EACE,iBAAiB,EAAE,2CAA2C,EAAE,kBAAkB;EAClF,gDAAgD;AAClD;AACA;EACE,WAAW,EAAE,YAAY,EAAE,iCAAiC,EAAE,4DAA4D,EAAE,kBAAkB;EAC9I,kCAAkC;AACpC;;AAEA,0BAA0B,gBAAgB,EAAE,cAAc,EAAE,iBAAiB,EAAE;AAC/E,gBAAgB,aAAa,EAAE,2DAA2D,EAAE,SAAS,EAAE,gBAAgB,EAAE;AACzH;EACE,mBAAmB,EAAE,uBAAuB,EAAE,aAAa,EAAE,sBAAsB,EAAE,MAAM,EAAE,kBAAkB;EAC/G,4BAA4B,EAAE,2CAA2C,EAAE,gDAAgD;AAC7H;AACA,0BAA0B,yBAAyB,EAAE,mBAAmB,EAAE;AAC1E;EACE,kBAAkB,EAAE,UAAU,EAAE,SAAS,EAAE,2BAA2B;EACtE,mBAAmB,EAAE,WAAW,EAAE,eAAe,EAAE,gBAAgB,EAAE,sBAAsB;EAC3F,iBAAiB,EAAE,mBAAmB,EAAE,mBAAmB;AAC7D;AACA,qBAAqB,eAAe,EAAE,kBAAkB,EAAE;AAC1D,sBAAsB,eAAe,EAAE,gBAAgB,EAAE,mCAAmC,EAAE,kBAAkB,EAAE;AAClH,wBAAwB,eAAe,EAAE,2CAA2C,EAAE,mBAAmB,EAAE;AAC3G,sBAAsB,eAAe,EAAE,gBAAgB,EAAE,mCAAmC,EAAE,uBAAuB,EAAE,kBAAkB,EAAE;AAC3I,2BAA2B,eAAe,EAAE,2CAA2C,EAAE,mBAAmB,EAAE;AAC9G,wBAAwB,oDAAoD,EAAE,cAAc,EAAE;AAC9F,wBAAwB,gBAAgB,EAAE,UAAU,EAAE,gBAAgB,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACzH,wBAAwB,aAAa,EAAE,uBAAuB,EAAE,QAAQ,EAAE,eAAe,EAAE,mCAAmC,EAAE;AAChI,qBAAqB,cAAc,EAAE,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AACvF;EACE,WAAW,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE,eAAe,EAAE,4BAA4B;EACrI,gBAAgB,EAAE,6CAA6C,EAAE,uBAAuB,EAAE,cAAc;AAC1G;AACA,oCAAoC,mBAAmB,EAAE,WAAW,EAAE,eAAe,EAAE;AACvF,qCAAqC,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE;AACrF;EACE,wDAAwD,EAAE,gDAAgD,EAAE,mBAAmB;EAC/H,kBAAkB,EAAE,mBAAmB;AACzC;AACA,sBAAsB,gBAAgB,EAAE,eAAe,EAAE,2CAA2C,EAAE,kBAAkB,EAAE;;AAE1H,0BAA0B;AAC1B;EACE,YAAY,EAAE,aAAa,EAAE,8DAA8D;EAC3F,aAAa,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,kBAAkB;AAC7E;AACA;EACE,kBAAkB,EAAE,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,YAAY;EAC3D,oDAAoD,EAAE,+DAA+D;EACrH,aAAa,EAAE,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,eAAe,EAAE,SAAS;EAC7G,yCAAyC;AAC3C;AACA;EACE,OAAO,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EACpE,4BAA4B,EAAE,WAAW,EAAE,YAAY,EAAE,sBAAsB;AACjF;AACA;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB;AAC/C;;AAEA,oCAAoC;AACpC;EACE,cAAc,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,WAAW,EAAE,YAAY;EAC9E,iBAAiB,EAAE,kBAAkB,EAAE,cAAc;AACvD;AACA,gCAAgC,gBAAgB,EAAE;;AAElD,mBAAmB;AACnB,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,uDAAuD,EAAE,2CAA2C,EAAE,0BAA0B,EAAE;AAC3L;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,YAAY;EACjH,oCAAoC,EAAE,gBAAgB,EAAE,eAAe,EAAE,6CAA6C;EACtH,mBAAmB,EAAE,iBAAiB,EAAE,gDAAgD;AAC1F;AACA,qBAAqB,+DAA+D,EAAE,gBAAgB,EAAE,mCAAmC,EAAE;AAC7I;EACE,OAAO,EAAE,uBAAuB,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,YAAY;EACnJ,oCAAoC,EAAE,gBAAgB,EAAE,eAAe,EAAE,6CAA6C;EACtH,mBAAmB,EAAE,iBAAiB;AACxC;AACA;EACE,wDAAwD,EAAE,+DAA+D;EACzH,gBAAgB,EAAE,mCAAmC;AACvD;;AAEA,sBAAsB;AACtB;EACE,gDAAgD,EAAE,sBAAsB,EAAE,wBAAwB;EAClG,kBAAkB,EAAE,gBAAgB,EAAE,2CAA2C;AACnF;AACA,sBAAsB,yDAAyD,EAAE;AACjF,uBAAuB,0DAA0D,EAAE;AACnF,mBAAmB,sDAAsD,EAAE;AAC3E;;EAEE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS;EAC7E,iBAAiB,EAAE,eAAe,EAAE,iBAAiB,EAAE,iCAAiC;AAC1F;AACA;2BAC2B,wDAAwD,EAAE;AACrF;EACE,aAAa,EAAE,QAAQ,EAAE,kBAAkB,EAAE,uDAAuD;EACpG,mBAAmB,EAAE,2CAA2C;AAClE;AACA,8BAA8B,mBAAmB,EAAE;AACnD;EACE,aAAa,EAAE,QAAQ,EAAE,iBAAiB,EAAE,wDAAwD;EACpG,uDAAuD,EAAE,mBAAmB;AAC9E;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;AAC9D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;;AAE1D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,2CAA2C;EAC3C,wDAAwD;EACxD,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB,SAAS,WAAW,EAAE;AACtB,aAAa,gBAAgB,EAAE;AAC/B,eAAe,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;AAC5E,WAAW,aAAa,EAAE;AAC1B,iBAAiB,aAAa,EAAE,OAAO,EAAE;AACzC,4BAA4B,mBAAmB,EAAE;;AAEjD,qCAAqC;AACrC;EACE,kBAAkB;EAClB,gBAAgB;EAChB;;;;;;;GAOC;EACD,0BAA0B;EAC1B,kDAAkD;EAClD,kBAAkB;AACpB;AACA,mBAAmB,kBAAkB,EAAE,EAAE,yBAAyB;AAClE,2BAA2B,KAAK,4BAA4B,EAAE,EAAE,OAAO,2BAA2B,EAAE,EAAE;;AAEtG,sBAAsB;AACtB,iBAAiB,WAAW,EAAE;AAC9B,iBAAiB,YAAY,EAAE;AAC/B,YAAY,SAAS,EAAE;AACvB,aAAa,WAAW,EAAE;;AAE1B,yDAAyD;AACzD,+BAA+B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,oDAAoD,EAAE;AAClJ,yBAAyB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;AACvE,8BAA8B,eAAe,EAAE;AAC/C,0BAA0B,kBAAkB,EAAE,kBAAkB,EAAE,eAAe,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,mDAAmD,EAAE,8BAA8B,EAAE,gEAAgE,EAAE;AACjR,oCAAoC,oDAAoD,EAAE,kDAAkD,EAAE;AAC9I,+BAA+B,kBAAkB,EAAE,mBAAmB,EAAE,0DAA0D,EAAE,iBAAiB,EAAE,8CAA8C,EAAE;AACvM,gBAAgB,iBAAiB,EAAE,2CAA2C,EAAE,kBAAkB,EAAE,gDAAgD,EAAE;AACtJ,cAAc,WAAW,EAAE,YAAY,EAAE,iCAAiC,EAAE,4DAA4D,EAAE,kBAAkB,EAAE,kCAAkC,EAAE;AAClM,kBAAkB,KAAK,uBAAuB,EAAE,EAAE,OAAO,yBAAyB,EAAE,EAAE;;AAEtF,wBAAwB;AACxB,0BAA0B,gBAAgB,EAAE,cAAc,EAAE,iBAAiB,EAAE;AAC/E,gBAAgB,aAAa,EAAE,2DAA2D,EAAE,SAAS,EAAE,gBAAgB,EAAE;AACzH;EACE,mBAAmB,EAAE,uBAAuB,EAAE,aAAa,EAAE,sBAAsB,EAAE,MAAM,EAAE,kBAAkB;EAC/G,4BAA4B,EAAE,2CAA2C,EAAE,gDAAgD;AAC7H;AACA,0BAA0B,yBAAyB,EAAE,mBAAmB,EAAE;AAC1E;EACE,kBAAkB,EAAE,UAAU,EAAE,SAAS,EAAE,2BAA2B;EACtE,mBAAmB,EAAE,WAAW,EAAE,eAAe,EAAE,gBAAgB,EAAE,sBAAsB;EAC3F,iBAAiB,EAAE,mBAAmB,EAAE,mBAAmB;AAC7D;AACA,qBAAqB,eAAe,EAAE,kBAAkB,EAAE;AAC1D,sBAAsB,eAAe,EAAE,gBAAgB,EAAE,mCAAmC,EAAE,kBAAkB,EAAE;AAClH,wBAAwB,eAAe,EAAE,2CAA2C,EAAE,mBAAmB,EAAE;AAC3G,sBAAsB,eAAe,EAAE,gBAAgB,EAAE,mCAAmC,EAAE,uBAAuB,EAAE,kBAAkB,EAAE;AAC3I,2BAA2B,eAAe,EAAE,2CAA2C,EAAE,mBAAmB,EAAE;AAC9G,wBAAwB,oDAAoD,EAAE,cAAc,EAAE;AAC9F,wBAAwB,gBAAgB,EAAE,UAAU,EAAE,gBAAgB,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACzH,wBAAwB,aAAa,EAAE,uBAAuB,EAAE,QAAQ,EAAE,eAAe,EAAE,mCAAmC,EAAE;AAChI,qBAAqB,cAAc,EAAE,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AACvF;EACE,WAAW,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE,eAAe,EAAE,4BAA4B;EACrI,gBAAgB,EAAE,6CAA6C,EAAE,uBAAuB,EAAE,cAAc;AAC1G;AACA,oCAAoC,mBAAmB,EAAE,WAAW,EAAE,eAAe,EAAE;AACvF,qCAAqC,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE;AACrF;EACE,wDAAwD,EAAE,gDAAgD,EAAE,mBAAmB;EAC/H,kBAAkB,EAAE,mBAAmB;AACzC;AACA,sBAAsB,gBAAgB,EAAE,eAAe,EAAE,2CAA2C,EAAE,kBAAkB,EAAE;;AAE1H,0BAA0B;AAC1B;EACE,YAAY,EAAE,aAAa,EAAE,8DAA8D;EAC3F,aAAa,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,kBAAkB;AAC7E;AACA;EACE,kBAAkB,EAAE,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,YAAY;EAC3D,oDAAoD,EAAE,+DAA+D;EACrH,aAAa,EAAE,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,eAAe,EAAE,SAAS;EAC7G,yCAAyC;AAC3C;AACA;EACE,OAAO,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EACpE,4BAA4B,EAAE,WAAW,EAAE,YAAY,EAAE,sBAAsB;AACjF;AACA;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB;AAC/C;;AAEA,oCAAoC;AACpC;EACE,cAAc,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,WAAW,EAAE,YAAY;EAC9E,iBAAiB,EAAE,kBAAkB,EAAE,cAAc;AACvD;AACA,gCAAgC,gBAAgB,EAAE;;AAElD,mBAAmB;AACnB,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,uDAAuD,EAAE,2CAA2C,EAAE,0BAA0B,EAAE;AAC3L;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,YAAY;EACjH,oCAAoC,EAAE,gBAAgB,EAAE,eAAe,EAAE,6CAA6C;EACtH,mBAAmB,EAAE,iBAAiB,EAAE,gDAAgD;AAC1F;AACA,qBAAqB,+DAA+D,EAAE,gBAAgB,EAAE,mCAAmC,EAAE;AAC7I;EACE,OAAO,EAAE,uBAAuB,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,YAAY;EACnJ,oCAAoC,EAAE,gBAAgB,EAAE,eAAe,EAAE,6CAA6C;EACtH,mBAAmB,EAAE,iBAAiB;AACxC;AACA;EACE,wDAAwD,EAAE,+DAA+D;EACzH,gBAAgB,EAAE,mCAAmC;AACvD;;AAEA,sBAAsB;AACtB;EACE,gDAAgD,EAAE,sBAAsB,EAAE,wBAAwB;EAClG,kBAAkB,EAAE,gBAAgB,EAAE,2CAA2C;AACnF;AACA,sBAAsB,yDAAyD,EAAE;AACjF,uBAAuB,0DAA0D,EAAE;AACnF,mBAAmB,sDAAsD,EAAE;AAC3E;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS;EAC7E,iBAAiB,EAAE,eAAe,EAAE,iBAAiB,EAAE,iCAAiC;AAC1F;AACA,sBAAsB,wDAAwD,EAAE;AAChF;EACE,aAAa,EAAE,QAAQ,EAAE,kBAAkB,EAAE,uDAAuD;EACpG,mBAAmB,EAAE,2CAA2C;AAClE;AACA,8BAA8B,mBAAmB,EAAE;AACnD;EACE,aAAa,EAAE,QAAQ,EAAE,iBAAiB,EAAE,wDAAwD;EACpG,uDAAuD,EAAE,mBAAmB;AAC9E;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA,qCAAqC;AACrC;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB,SAAS,WAAW,EAAE;AACtB,aAAa,gBAAgB,EAAE;AAC/B,eAAe,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;AAC5E,WAAW,aAAa,EAAE;AAC1B,iBAAiB,aAAa,EAAE,OAAO,EAAE;AACzC,4BAA4B,mBAAmB,EAAE;;AAEjD,0DAA0D;AAC1D,8CAA8C;AAC9C;EACE,WAAW;AACb;AACA;EACE,2CAA2C;AAC7C;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,gBAAgB;EAChB;;;;;;;GAOC;EACD,0BAA0B;EAC1B,kDAAkD;EAClD,kBAAkB;AACpB;AACA,mBAAmB,kBAAkB,EAAE,EAAE,yBAAyB;AAClE,2BAA2B,KAAK,4BAA4B,EAAE,EAAE,OAAO,2BAA2B,EAAE,EAAE;;AAEtG,sBAAsB;AACtB,iBAAiB,WAAW,EAAE;AAC9B,iBAAiB,YAAY,EAAE;AAC/B,YAAY,SAAS,EAAE;AACvB,aAAa,WAAW,EAAE;;AAE1B,iFAAiF;AACjF;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,oBAAoB;EACpB,wEAAwE;AAC1E;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,UAAU;EACV,4CAA4C;AAC9C;;AAEA,kFAAkF;AAClF;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,+DAA+D;EAC/D,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,OAAO;AACT;;AAEA,kFAAkF;AAClF;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA,kFAAkF;AAClF;EACE,yBAAyB;AAC3B;;AAEA,kFAAkF;AAClF,uBAAuB,aAAa,EAAE","sourcesContent":["/* Before/after compare slider (ImageCompareSlider + modal) */\n.compare-slider-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n  max-height: 100%;\n  min-height: 400px;\n  overflow: hidden;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.compare-slider-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  object-position: center center;\n  user-select: none;\n  pointer-events: none;\n  min-width: 100%;\n  min-height: 100%;\n}\n\n.compare-slider-foreground {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 50%;\n  height: 100%;\n  overflow: hidden;\n  border-right: 3px solid #fff;\n  box-sizing: border-box;\n  z-index: 2;\n}\n\n.compare-slider-original {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  object-fit: contain;\n  object-position: center center;\n  user-select: none;\n  pointer-events: none;\n  min-height: 100%;\n}\n\n.compare-slider-handle {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  width: 60px;\n  height: 100%;\n  cursor: col-resize;\n  z-index: 10;\n  transform: translateX(-50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.compare-slider-handle-line {\n  width: 4px;\n  height: 100%;\n  background-color: #fff;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n  position: relative;\n}\n\n.compare-slider-handle-circle {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background-color: #fff;\n  border: 3px solid #000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.4);\n  cursor: col-resize;\n}\n\n.compare-slider-handle-icon {\n  font-size: 20px;\n  font-weight: bold;\n  user-select: none;\n}\n\n.compare-stats {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.compare-stat-badge {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n/* Manual upload / batch table thumbnails — never expand to intrinsic image size */\n.batch-thumb-cell {\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: 6px;\n  overflow: hidden;\n  background: var(--p-color-bg-subdued, #f6f6f7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.batch-file-thumbnail {\n  width: 40px;\n  height: 40px;\n  object-fit: cover;\n  display: block;\n  vertical-align: middle;\n}\n\n.batch-file-thumbnail-placeholder {\n  font-size: 18px;\n  line-height: 40px;\n  text-align: center;\n}\n\n.batch-file-name-wrap {\n  min-width: 0;\n}\n\n.batch-file-sub {\n  display: block;\n  margin-top: 2px;\n}\n\n/* Job image rows in OptimizationProgress accordion */\n.job-image-row {\n  padding: var(--p-space-300, 12px);\n  border: 1px solid var(--p-color-border, #e1e3e5);\n  border-radius: var(--p-border-radius-200, 8px);\n  background: var(--p-color-bg, #ffffff);\n  transition: background 0.15s ease;\n}\n\n.job-image-row--clickable {\n  cursor: pointer;\n}\n\n.job-image-row--clickable:hover {\n  background: var(--p-color-bg-surface-hover, #f6f6f7);\n}\n\n/* Progress Bar Styles */\n.progress-bar-container {\n  width: 100%;\n  height: 24px;\n  background-color: #e1e3e5;\n  border-radius: 4px;\n  overflow: hidden;\n  position: relative;\n  border: 1px solid #c9cccf;\n}\n\n.progress-bar-fill {\n  height: 100%;\n  background-color: var(--p-color-bg-success, #008060);\n  transition: width 0.3s ease;\n  border-radius: 4px;\n  min-width: 0;\n  position: relative;\n  overflow: hidden;\n}\n\n.progress-bar-fill.progress-in-progress {\n  background-color: var(--p-color-bg-warning, #f59e0b);\n}\n\n.progress-bar-fill.progress-completed {\n  background-color: var(--p-color-bg-success, #008060);\n}\n\n.progress-bar-fill.progress-in-progress::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\n  animation: shimmer 2s infinite;\n}\n\n@keyframes shimmer {\n  0% { transform: translateX(-100%); }\n  100% { transform: translateX(100%); }\n}\n\n/* Initial app loading state - full width */\n.app-loading-section {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n.app-loading-content {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n.app-loading-shimmer {\n  width: 100%;\n  height: 200px;\n  border-radius: 8px;\n  margin-top: 0.5rem;\n}\n\n/* Skeleton / Shimmer Loader Styles */\n.shimmer-loader {\n  position: relative;\n  overflow: hidden;\n  background: linear-gradient(\n    90deg,\n    #e1e3e5 0%,\n    #e1e3e5 40%,\n    rgba(255, 255, 255, 0.6) 50%,\n    #e1e3e5 60%,\n    #e1e3e5 100%\n  );\n  background-size: 200% 100%;\n  animation: shimmer-slide 1.5s ease-in-out infinite;\n  border-radius: 4px;\n}\n\n@keyframes shimmer-slide {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n.shimmer-text-small {\n  height: 11px;\n  width: 60px;\n}\n\n.shimmer-text-medium {\n  height: 14px;\n  width: 80px;\n}\n\n.shimmer-heading {\n  height: 32px;\n  width: 100px;\n}\n\n/* Credits Widget: no custom CSS needed — uses Shopify s-* components */\n\n/* Info tooltip (ⓘ icon with hover bubble) */\n\n/* Sticky Layout Classes */\n.sticky-header {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background-color: var(--p-color-bg-surface, #ffffff);\n  padding-bottom: 8px;\n}\n\n.sticky-footer {\n  position: sticky;\n  bottom: 0;\n  z-index: 10;\n  background-color: var(--p-color-bg-surface, #ffffff);\n  padding-top: 16px;\n  padding-bottom: 8px;\n  border-top: 1px solid var(--p-color-border-subdued, #e1e3e5);\n}\n\n/* Product Row Styles */\n.product-thumbnail-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--p-color-bg-subdued, #f6f6f7);\n}\n\n.product-thumbnail-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.product-thumbnail-fallback {\n  font-size: 20px;\n}\n\n/* Image Management Table Styles */\n.image-management-table {\n  border: 1px solid var(--p-color-border, #e3e3e3);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.image-management-header {\n  display: grid;\n  grid-template-columns: auto auto 1fr auto;\n  gap: 16px;\n  padding: 8px 12px;\n  background: var(--p-color-bg-surface-secondary, #f7f7f7);\n  border-bottom: 1px solid var(--p-color-border, #e3e3e3);\n  align-items: center;\n}\n\n.image-management-product-row {\n  border-bottom: 1px solid var(--p-color-border, #e3e3e3);\n}\n\n.clickable-row {\n  cursor: pointer;\n  padding: 8px 16px;\n  transition: background-color 0.1s;\n}\n\n.clickable-row:hover {\n  background-color: var(--p-color-bg-surface-hover, #f1f1f1);\n}\n\n.image-management-nested-images {\n  padding: 4px 16px 12px 48px;\n  margin: 0;\n  border-left: none;\n  background: var(--p-color-bg-surface-secondary, #fafafa);\n  border-top: 1px solid var(--p-color-border-subdued, #e1e3e5);\n}\n\n/* ProductSelection flat list (no accordion) */\n.ps-product-list-header {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 16px;\n  padding: 10px 16px;\n  border-bottom: 1px solid var(--p-color-border, #e3e3e3);\n  background: var(--p-color-bg-surface-secondary, #f7f7f7);\n}\n\n.ps-product-list-row {\n  display: grid;\n  grid-template-columns: auto auto 1fr auto;\n  gap: 12px;\n  align-items: center;\n  padding: 10px 16px;\n}\n\n.ps-product-title {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ps-remaining-count {\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n  color: var(--p-color-text-secondary, #616161);\n}\n\n/* ImageRow inside nested images — plain div for predictable bg */\n.image-row-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 16px;\n  border-top: 1px solid var(--p-color-border-subdued, #e1e3e5);\n  background: transparent;\n  cursor: pointer;\n  transition: background-color 0.1s;\n}\n\n.image-row-item:hover {\n  background-color: rgba(0, 0, 0, 0.03);\n}\n\n.image-row-item:first-child {\n  border-top: none;\n}\n\n/* Manual Upload Styles */\n.mu-session-expanded-content {\n  padding: 8px 16px 12px 16px;\n  margin: 0;\n  border-left: none;\n  background: transparent;\n}\n\n.mu-file-card {\n  padding: 8px 12px;\n  background: var(--p-color-bg-surface, #ffffff);\n  border-radius: 8px;\n  border: 1px solid var(--p-color-border, #e3e3e3);\n}\n\n.mu-drop-zone-container {\n  padding: 56px 24px;\n  text-align: center;\n  cursor: pointer;\n  user-select: none;\n  border-radius: 7px;\n  background-color: var(--p-surface-subdued, #FAFBFB);\n  border: 2px dashed transparent;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n\n.mu-drop-zone-container.drag-over {\n  background-color: var(--p-surface-selected, #F2F7FE);\n  border-color: var(--p-border-interactive, #2C6ECB);\n}\n\n/* Pricing Page Styles */\n.pricing-page-container {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 0 0 48px;\n}\n\n.pricing-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 20px;\n  margin-top: 24px;\n}\n\n.pricing-card {\n  border-radius: 12px;\n  padding: 28px 24px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  position: relative;\n  transition: box-shadow 0.15s;\n  background: var(--p-color-bg-surface, #fff);\n  border: 1px solid var(--p-color-border, #e3e3e3);\n}\n\n.pricing-card-highlight {\n  border: 2px solid #2c6ecb;\n  background: #f0f6ff;\n}\n\n.pricing-popular-badge {\n  position: absolute;\n  top: -12px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: #2c6ecb;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  padding: 3px 12px;\n  border-radius: 20px;\n  white-space: nowrap;\n}\n\n.pricing-card-icon {\n  font-size: 32px;\n  margin-bottom: 8px;\n}\n\n.pricing-card-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--p-color-text, #202223);\n  margin-bottom: 2px;\n}\n\n.pricing-card-credits {\n  font-size: 15px;\n  color: var(--p-color-text-subdued, #616161);\n  margin-bottom: 16px;\n}\n\n.pricing-card-price {\n  font-size: 32px;\n  font-weight: 800;\n  color: var(--p-color-text, #202223);\n  letter-spacing: -0.02em;\n  margin-bottom: 4px;\n}\n\n.pricing-card-price-note {\n  font-size: 12px;\n  color: var(--p-color-text-subdued, #616161);\n  margin-bottom: 20px;\n}\n\n.pricing-card-divider {\n  border-top: 1px solid var(--p-color-border, #e3e3e3);\n  margin: 16px 0;\n}\n\n.pricing-feature-list {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.pricing-feature-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 13px;\n  color: var(--p-color-text, #202223);\n}\n\n.pricing-checkmark {\n  color: #36a420;\n  font-size: 14px;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.pricing-purchase-button {\n  width: 100%;\n  padding: 10px 16px;\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.15s;\n  margin-top: auto;\n  border: 1px solid var(--p-color-border, #ccc);\n  background: transparent;\n  color: #202223;\n}\n\n.pricing-purchase-button:disabled {\n  background: #e9ecef;\n  color: #999;\n  cursor: default;\n}\n\n.pricing-purchase-button-highlight {\n  background: #2c6ecb;\n  color: #fff;\n  border: none;\n}\n\n.pricing-balance-box {\n  background: var(--p-color-bg-surface-secondary, #f6f6f7);\n  border: 1px solid var(--p-color-border, #e3e3e3);\n  border-radius: 10px;\n  padding: 20px 24px;\n  margin-bottom: 32px;\n}\n\n.pricing-fine-print {\n  margin-top: 32px;\n  font-size: 12px;\n  color: var(--p-color-text-subdued, #616161);\n  text-align: center;\n}\n\n/* Public Compare Styles */\n.public-compare-container {\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--p-color-bg-surface-secondary, #F6F6F7);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  position: relative;\n}\n\n.public-compare-header {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 100;\n  background-color: var(--p-color-bg-surface, #FFFFFF);\n  border-bottom: 1px solid var(--p-color-border-subdued, #E1E3E5);\n  padding: 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.05);\n}\n\n.public-compare-body {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 80px 16px 16px 16px;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n}\n\n.public-compare-slider-wrapper {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n.flex-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.h-100vh {\n  height: 100vh;\n}\n\n/* Public JSON Optimization Styles */\n.public-json-img-preview {\n  flex-shrink: 0;\n  max-width: 150px;\n  max-height: 150px;\n  width: auto;\n  height: auto;\n  object-fit: cover;\n  border-radius: 8px;\n  display: block;\n}\n\n.public-json-slider-container {\n  margin-top: 16px;\n}\n\n/* Tab Bar Styles */\n.tab-bar-container {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--p-color-border, #e3e3e3);\n  background: var(--p-color-bg-surface, #fff);\n  border-radius: 8px 8px 0 0;\n}\n\n.tab-button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 12px 20px;\n  cursor: pointer;\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  font-weight: 400;\n  font-size: 14px;\n  color: var(--p-color-text-secondary, #616161);\n  margin-bottom: -1px;\n  user-select: none;\n  transition: color 0.1s, border-bottom-color 0.1s;\n}\n\n.tab-button-active {\n  border-bottom-color: var(--p-color-border-interactive, #005bd3);\n  font-weight: 600;\n  color: var(--p-color-text, #1a1a1a);\n}\n\n.tab-container-flex {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  min-width: 0;\n}\n\n.tab-bar-action {\n  margin-left: auto;\n  padding: 0 8px;\n  flex-shrink: 0;\n}\n\n.sub-tab-button {\n  flex: 1;\n  justify-content: center;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 16px;\n  cursor: pointer;\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  font-weight: 400;\n  font-size: 13px;\n  color: var(--p-color-text-secondary, #616161);\n  margin-bottom: -1px;\n  user-select: none;\n}\n\n.sub-tab-button-active {\n  background: var(--p-color-bg-surface-secondary, #f7f7f7);\n  border-bottom-color: var(--p-color-border-interactive, #005bd3);\n  font-weight: 600;\n  color: var(--p-color-text, #1a1a1a);\n}\n\n/* Batch Card Styles */\n.batch-card {\n  border: 1px solid var(--p-color-border, #e3e3e3);\n  border-left-width: 4px;\n  border-left-style: solid;\n  border-radius: 8px;\n  overflow: hidden;\n  background: var(--p-color-bg-surface, #fff);\n}\n\n.batch-card-success { border-left-color: var(--p-color-border-success, #1a7f5a); }\n.batch-card-critical { border-left-color: var(--p-color-border-critical, #d72c0d); }\n.batch-card-info { border-left-color: var(--p-color-border-info, #007ace); }\n\n.batch-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 8px 12px; /* Changed padding to match standard spacing */\n  cursor: pointer;\n  user-select: none;\n  transition: background 0.15s ease;\n}\n\n.batch-header:hover { background: var(--p-color-bg-surface-secondary, #f7f7f7); }\n\n.batch-table-row {\n  display: grid;\n  gap: 8px;\n  padding: 10px 12px;\n  border-bottom: 1px solid var(--p-color-border, #e3e3e3);\n  align-items: center;\n  background: var(--p-color-bg-surface, #fff);\n}\n\n.batch-table-row:last-child { border-bottom: none; }\n\n.batch-table-header {\n  display: grid;\n  gap: 8px;\n  padding: 8px 12px;\n  background: var(--p-color-bg-surface-secondary, #f7f7f7);\n  border-bottom: 1px solid var(--p-color-border, #e3e3e3);\n  align-items: center;\n}\n\n/* Utility Classes */\n.w-100 { width: 100%; }\n.max-w-400 { max-width: 400px; }\n.flex-center { display: flex; align-items: center; justify-content: center; }\n.h-100vh { height: 100vh; }\n.tab-container { display: flex; flex: 1; }\n.tab-new-button-container { padding-right: 10px; }\n\n/* Old styles that might be unused now, but kept for now */\n/* List-structure skeleton for listing pages */\n.list-skeleton-wrapper {\n  width: 100%;\n}\n.list-skeleton-row {\n  background: var(--p-color-bg-surface, #fff);\n}\n\n/* Skeleton / Shimmer Loader Styles */\n.shimmer-loader {\n  position: relative;\n  overflow: hidden;\n  background: linear-gradient(\n    90deg,\n    #e1e3e5 0%,\n    #e1e3e5 40%,\n    rgba(255, 255, 255, 0.6) 50%,\n    #e1e3e5 60%,\n    #e1e3e5 100%\n  );\n  background-size: 200% 100%;\n  animation: shimmer-slide 1.5s ease-in-out infinite;\n  border-radius: 4px;\n}\n\n@keyframes shimmer-slide {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n.shimmer-text-small { height: 11px; width: 60px; }\n.shimmer-text-medium { height: 14px; width: 80px; }\n.shimmer-heading { height: 32px; width: 100px; }\n.shimmer-rounded { border-radius: 4px; } /* Added for rounded shimmers */\n\n/* Spacing utilities */\n.gap-small-100 { gap: 0.5rem; }\n.gap-small-200 { gap: 0.75rem; }\n.gap-base { gap: 1rem; }\n.gap-large { gap: 1.5rem; }\n\n/* Specific component styling, moved from inline styles */\n.product-thumbnail-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--p-color-bg-subdued, #f6f6f7);\n}\n.product-thumbnail-img {\n  width: 100%; height: 100%; object-fit: cover;\n}\n.product-thumbnail-fallback { font-size: 20px; }\n\n.mu-drop-zone-container {\n  padding: 56px 24px; text-align: center; cursor: pointer; user-select: none;\n  border-radius: 7px; background-color: var(--p-surface-subdued, #FAFBFB);\n  border: 2px dashed transparent; transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n.mu-drop-zone-container.drag-over {\n  background-color: var(--p-surface-selected, #F2F7FE);\n  border-color: var(--p-border-interactive, #2C6ECB);\n}\n.mu-session-expanded-content {\n  padding-left: 56px; padding-right: 16px; border-left: 3px solid var(--p-color-border-info, #007ace);\n  margin-left: 16px; background: var(--p-color-bg-subdued, #f6f6f7);\n}\n.mu-file-card {\n  padding: 8px 12px; background: var(--p-color-bg-surface, #fff); border-radius: 8px;\n  border: 1px solid var(--p-color-border, #e3e3e3);\n}\n.mu-spinner {\n  width: 32px; height: 32px; border: 3px solid rgba(0,0,0,0.1); border-top-color: var(--p-color-border-interactive, #005bd3); border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.pricing-page-container { max-width: 900px; margin: 0 auto; padding: 0 0 48px; }\n.pricing-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 20px; margin-top: 24px; }\n.pricing-card {\n  border-radius: 12px; padding: 28px 24px 24px; display: flex; flex-direction: column; gap: 0; position: relative;\n  transition: box-shadow 0.15s; background: var(--p-color-bg-surface, #fff); border: 1px solid var(--p-color-border, #e3e3e3);\n}\n.pricing-card-highlight { border: 2px solid #2c6ecb; background: #f0f6ff; }\n.pricing-popular-badge {\n  position: absolute; top: -12px; left: 50%; transform: translateX(-50%);\n  background: #2c6ecb; color: #fff; font-size: 11px; font-weight: 700; letter-spacing: 0.05em;\n  padding: 3px 12px; border-radius: 20px; white-space: nowrap;\n}\n.pricing-card-icon { font-size: 32px; margin-bottom: 8px; }\n.pricing-card-title { font-size: 20px; font-weight: 700; color: var(--p-color-text, #202223); margin-bottom: 2px; }\n.pricing-card-credits { font-size: 15px; color: var(--p-color-text-subdued, #616161); margin-bottom: 16px; }\n.pricing-card-price { font-size: 32px; font-weight: 800; color: var(--p-color-text, #202223); letter-spacing: -0.02em; margin-bottom: 4px; }\n.pricing-card-price-note { font-size: 12px; color: var(--p-color-text-subdued, #616161); margin-bottom: 20px; }\n.pricing-card-divider { border-top: 1px solid var(--p-color-border, #e3e3e3); margin: 16px 0; }\n.pricing-feature-list { list-style: none; padding: 0; margin: 0 0 24px; display: flex; flex-direction: column; gap: 8px; }\n.pricing-feature-item { display: flex; align-items: flex-start; gap: 8px; font-size: 13px; color: var(--p-color-text, #202223); }\n.pricing-checkmark { color: #36a420; font-size: 14px; flex-shrink: 0; margin-top: 1px; }\n.pricing-purchase-button {\n  width: 100%; padding: 10px 16px; border-radius: 8px; font-weight: 600; font-size: 14px; cursor: pointer; transition: background 0.15s;\n  margin-top: auto; border: 1px solid var(--p-color-border, #ccc); background: transparent; color: #202223;\n}\n.pricing-purchase-button:disabled { background: #e9ecef; color: #999; cursor: default; }\n.pricing-purchase-button-highlight { background: #2c6ecb; color: #fff; border: none; }\n.pricing-balance-box {\n  background: var(--p-color-bg-surface-secondary, #f6f6f7); border: 1px solid var(--p-color-border, #e3e3e3); border-radius: 10px;\n  padding: 20px 24px; margin-bottom: 32px;\n}\n.pricing-fine-print { margin-top: 32px; font-size: 12px; color: var(--p-color-text-subdued, #616161); text-align: center; }\n\n/* Public Compare Styles */\n.public-compare-container {\n  width: 100vw; height: 100vh; background-color: var(--p-color-bg-surface-secondary, #F6F6F7);\n  display: flex; flex-direction: column; overflow: hidden; position: relative;\n}\n.public-compare-header {\n  position: absolute; top: 0; left: 0; right: 0; z-index: 100;\n  background-color: var(--p-color-bg-surface, #FFFFFF); border-bottom: 1px solid var(--p-color-border-subdued, #E1E3E5);\n  padding: 16px; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 16px;\n  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.05);\n}\n.public-compare-body {\n  flex: 1; display: flex; align-items: center; justify-content: center;\n  padding: 80px 16px 16px 16px; width: 100%; height: 100%; box-sizing: border-box;\n}\n.public-compare-slider-wrapper {\n  width: 100%; height: 100%; position: relative;\n}\n\n/* Public JSON Optimization Styles */\n.public-json-img-preview {\n  flex-shrink: 0; max-width: 150px; max-height: 150px; width: auto; height: auto;\n  object-fit: cover; border-radius: 8px; display: block;\n}\n.public-json-slider-container { margin-top: 16px; }\n\n/* Tab Bar Styles */\n.tab-bar-container { display: flex; align-items: center; border-bottom: 1px solid var(--p-color-border, #e3e3e3); background: var(--p-color-bg-surface, #fff); border-radius: 8px 8px 0 0; }\n.tab-button {\n  display: flex; align-items: center; gap: 6px; padding: 12px 20px; cursor: pointer; background: none; border: none;\n  border-bottom: 2px solid transparent; font-weight: 400; font-size: 14px; color: var(--p-color-text-secondary, #616161);\n  margin-bottom: -1px; user-select: none; transition: color 0.1s, border-bottom-color 0.1s;\n}\n.tab-button-active { border-bottom-color: var(--p-color-border-interactive, #005bd3); font-weight: 600; color: var(--p-color-text, #1a1a1a); }\n.sub-tab-button {\n  flex: 1; justify-content: center; display: flex; align-items: center; gap: 6px; padding: 10px 16px; cursor: pointer; background: none; border: none;\n  border-bottom: 2px solid transparent; font-weight: 400; font-size: 13px; color: var(--p-color-text-secondary, #616161);\n  margin-bottom: -1px; user-select: none;\n}\n.sub-tab-button-active {\n  background: var(--p-color-bg-surface-secondary, #f7f7f7); border-bottom-color: var(--p-color-border-interactive, #005bd3);\n  font-weight: 600; color: var(--p-color-text, #1a1a1a);\n}\n\n/* Batch Card Styles */\n.batch-card {\n  border: 1px solid var(--p-color-border, #e3e3e3); border-left-width: 4px; border-left-style: solid;\n  border-radius: 8px; overflow: hidden; background: var(--p-color-bg-surface, #fff);\n}\n.batch-card-success { border-left-color: var(--p-color-border-success, #1a7f5a); }\n.batch-card-critical { border-left-color: var(--p-color-border-critical, #d72c0d); }\n.batch-card-info { border-left-color: var(--p-color-border-info, #007ace); }\n.batch-header,\n.batch-card-header {\n  display: flex; align-items: center; justify-content: space-between; gap: 12px;\n  padding: 8px 12px; cursor: pointer; user-select: none; transition: background 0.15s ease;\n}\n.batch-header:hover,\n.batch-card-header:hover { background: var(--p-color-bg-surface-secondary, #f7f7f7); }\n.batch-table-row {\n  display: grid; gap: 8px; padding: 10px 12px; border-bottom: 1px solid var(--p-color-border, #e3e3e3);\n  align-items: center; background: var(--p-color-bg-surface, #fff);\n}\n.batch-table-row:last-child { border-bottom: none; }\n.batch-table-header {\n  display: grid; gap: 8px; padding: 8px 12px; background: var(--p-color-bg-surface-secondary, #f7f7f7);\n  border-bottom: 1px solid var(--p-color-border, #e3e3e3); align-items: center;\n}\n\n.mu-status-pill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n  padding: 2px 8px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.3;\n}\n.mu-status-done { background: #e3f1df; color: #0b7b5e; }\n.mu-status-compressing { background: #e8f2ff; color: #005bd3; }\n.mu-status-waiting { background: #f3f2ef; color: #6d7175; }\n.mu-status-processing { background: #e8f2ff; color: #005bd3; }\n.mu-status-pending { background: #f3f2ef; color: #6d7175; }\n.mu-status-failed { background: #fde2dd; color: #b42318; }\n.mu-status-skipped { background: #fff1dc; color: #8a6116; }\n\n.batch-actions {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.batch-action-btn {\n  white-space: nowrap;\n}\n\n.mu-session-summary-row {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n  padding: 10px 12px;\n  border-top: none;\n  margin-bottom: 8px;\n  background: var(--p-color-bg-surface-secondary, #f7f7f7);\n}\n\n.mu-session-summary-card {\n  background: var(--p-color-bg-surface, #fff);\n  border: 1px solid var(--p-color-border-subdued, #e1e3e5);\n  border-radius: 8px;\n  padding: 8px 10px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n/* Utility Classes */\n.w-100 { width: 100%; }\n.max-w-400 { max-width: 400px; }\n.flex-center { display: flex; align-items: center; justify-content: center; }\n.h-100vh { height: 100vh; }\n.tab-container { display: flex; flex: 1; }\n.tab-new-button-container { padding-right: 10px; }\n\n/* Skeleton / Shimmer Loader Styles */\n.shimmer-loader {\n  position: relative;\n  overflow: hidden;\n  background: linear-gradient(\n    90deg,\n    #e1e3e5 0%,\n    #e1e3e5 40%,\n    rgba(255, 255, 255, 0.6) 50%,\n    #e1e3e5 60%,\n    #e1e3e5 100%\n  );\n  background-size: 200% 100%;\n  animation: shimmer-slide 1.5s ease-in-out infinite;\n  border-radius: 4px;\n}\n.shimmer-rounded { border-radius: 4px; } /* For rounded shimmers */\n@keyframes shimmer-slide { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }\n\n/* Spacing utilities */\n.gap-small-100 { gap: 0.5rem; }\n.gap-small-200 { gap: 0.75rem; }\n.gap-base { gap: 1rem; }\n.gap-large { gap: 1.5rem; }\n\n/* Specific component styling, moved from inline styles */\n.product-thumbnail-container { display: flex; align-items: center; justify-content: center; background-color: var(--p-color-bg-subdued, #f6f6f7); }\n.product-thumbnail-img { width: 100%; height: 100%; object-fit: cover; }\n.product-thumbnail-fallback { font-size: 20px; }\n.mu-drop-zone-container { padding: 56px 24px; text-align: center; cursor: pointer; user-select: none; border-radius: 7px; background-color: var(--p-surface-subdued, #FAFBFB); border: 2px dashed transparent; transition: background-color 0.15s ease, border-color 0.15s ease; }\n.mu-drop-zone-container.drag-over { background-color: var(--p-surface-selected, #F2F7FE); border-color: var(--p-border-interactive, #2C6ECB); }\n.mu-session-expanded-content { padding-left: 56px; padding-right: 16px; border-left: 3px solid var(--p-color-border-info, #007ace); margin-left: 16px; background: var(--p-color-bg-subdued, #f6f6f7); }\n.mu-file-card { padding: 8px 12px; background: var(--p-color-bg-surface, #fff); border-radius: 8px; border: 1px solid var(--p-color-border, #e3e3e3); }\n.mu-spinner { width: 32px; height: 32px; border: 3px solid rgba(0,0,0,0.1); border-top-color: var(--p-color-border-interactive, #005bd3); border-radius: 50%; animation: spin 1s linear infinite; }\n@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }\n\n/* Pricing Page Styles */\n.pricing-page-container { max-width: 900px; margin: 0 auto; padding: 0 0 48px; }\n.pricing-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 20px; margin-top: 24px; }\n.pricing-card {\n  border-radius: 12px; padding: 28px 24px 24px; display: flex; flex-direction: column; gap: 0; position: relative;\n  transition: box-shadow 0.15s; background: var(--p-color-bg-surface, #fff); border: 1px solid var(--p-color-border, #e3e3e3);\n}\n.pricing-card-highlight { border: 2px solid #2c6ecb; background: #f0f6ff; }\n.pricing-popular-badge {\n  position: absolute; top: -12px; left: 50%; transform: translateX(-50%);\n  background: #2c6ecb; color: #fff; font-size: 11px; font-weight: 700; letter-spacing: 0.05em;\n  padding: 3px 12px; border-radius: 20px; white-space: nowrap;\n}\n.pricing-card-icon { font-size: 32px; margin-bottom: 8px; }\n.pricing-card-title { font-size: 20px; font-weight: 700; color: var(--p-color-text, #202223); margin-bottom: 2px; }\n.pricing-card-credits { font-size: 15px; color: var(--p-color-text-subdued, #616161); margin-bottom: 16px; }\n.pricing-card-price { font-size: 32px; font-weight: 800; color: var(--p-color-text, #202223); letter-spacing: -0.02em; margin-bottom: 4px; }\n.pricing-card-price-note { font-size: 12px; color: var(--p-color-text-subdued, #616161); margin-bottom: 20px; }\n.pricing-card-divider { border-top: 1px solid var(--p-color-border, #e3e3e3); margin: 16px 0; }\n.pricing-feature-list { list-style: none; padding: 0; margin: 0 0 24px; display: flex; flex-direction: column; gap: 8px; }\n.pricing-feature-item { display: flex; align-items: flex-start; gap: 8px; font-size: 13px; color: var(--p-color-text, #202223); }\n.pricing-checkmark { color: #36a420; font-size: 14px; flex-shrink: 0; margin-top: 1px; }\n.pricing-purchase-button {\n  width: 100%; padding: 10px 16px; border-radius: 8px; font-weight: 600; font-size: 14px; cursor: pointer; transition: background 0.15s;\n  margin-top: auto; border: 1px solid var(--p-color-border, #ccc); background: transparent; color: #202223;\n}\n.pricing-purchase-button:disabled { background: #e9ecef; color: #999; cursor: default; }\n.pricing-purchase-button-highlight { background: #2c6ecb; color: #fff; border: none; }\n.pricing-balance-box {\n  background: var(--p-color-bg-surface-secondary, #f6f6f7); border: 1px solid var(--p-color-border, #e3e3e3); border-radius: 10px;\n  padding: 20px 24px; margin-bottom: 32px;\n}\n.pricing-fine-print { margin-top: 32px; font-size: 12px; color: var(--p-color-text-subdued, #616161); text-align: center; }\n\n/* Public Compare Styles */\n.public-compare-container {\n  width: 100vw; height: 100vh; background-color: var(--p-color-bg-surface-secondary, #F6F6F7);\n  display: flex; flex-direction: column; overflow: hidden; position: relative;\n}\n.public-compare-header {\n  position: absolute; top: 0; left: 0; right: 0; z-index: 100;\n  background-color: var(--p-color-bg-surface, #FFFFFF); border-bottom: 1px solid var(--p-color-border-subdued, #E1E3E5);\n  padding: 16px; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 16px;\n  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.05);\n}\n.public-compare-body {\n  flex: 1; display: flex; align-items: center; justify-content: center;\n  padding: 80px 16px 16px 16px; width: 100%; height: 100%; box-sizing: border-box;\n}\n.public-compare-slider-wrapper {\n  width: 100%; height: 100%; position: relative;\n}\n\n/* Public JSON Optimization Styles */\n.public-json-img-preview {\n  flex-shrink: 0; max-width: 150px; max-height: 150px; width: auto; height: auto;\n  object-fit: cover; border-radius: 8px; display: block;\n}\n.public-json-slider-container { margin-top: 16px; }\n\n/* Tab Bar Styles */\n.tab-bar-container { display: flex; align-items: center; border-bottom: 1px solid var(--p-color-border, #e3e3e3); background: var(--p-color-bg-surface, #fff); border-radius: 8px 8px 0 0; }\n.tab-button {\n  display: flex; align-items: center; gap: 6px; padding: 12px 20px; cursor: pointer; background: none; border: none;\n  border-bottom: 2px solid transparent; font-weight: 400; font-size: 14px; color: var(--p-color-text-secondary, #616161);\n  margin-bottom: -1px; user-select: none; transition: color 0.1s, border-bottom-color 0.1s;\n}\n.tab-button-active { border-bottom-color: var(--p-color-border-interactive, #005bd3); font-weight: 600; color: var(--p-color-text, #1a1a1a); }\n.sub-tab-button {\n  flex: 1; justify-content: center; display: flex; align-items: center; gap: 6px; padding: 10px 16px; cursor: pointer; background: none; border: none;\n  border-bottom: 2px solid transparent; font-weight: 400; font-size: 13px; color: var(--p-color-text-secondary, #616161);\n  margin-bottom: -1px; user-select: none;\n}\n.sub-tab-button-active {\n  background: var(--p-color-bg-surface-secondary, #f7f7f7); border-bottom-color: var(--p-color-border-interactive, #005bd3);\n  font-weight: 600; color: var(--p-color-text, #1a1a1a);\n}\n\n/* Batch Card Styles */\n.batch-card {\n  border: 1px solid var(--p-color-border, #e3e3e3); border-left-width: 4px; border-left-style: solid;\n  border-radius: 8px; overflow: hidden; background: var(--p-color-bg-surface, #fff);\n}\n.batch-card-success { border-left-color: var(--p-color-border-success, #1a7f5a); }\n.batch-card-critical { border-left-color: var(--p-color-border-critical, #d72c0d); }\n.batch-card-info { border-left-color: var(--p-color-border-info, #007ace); }\n.batch-header {\n  display: flex; align-items: center; justify-content: space-between; gap: 12px;\n  padding: 8px 12px; cursor: pointer; user-select: none; transition: background 0.15s ease;\n}\n.batch-header:hover { background: var(--p-color-bg-surface-secondary, #f7f7f7); }\n.batch-table-row {\n  display: grid; gap: 8px; padding: 10px 12px; border-bottom: 1px solid var(--p-color-border, #e3e3e3);\n  align-items: center; background: var(--p-color-bg-surface, #fff);\n}\n.batch-table-row:last-child { border-bottom: none; }\n.batch-table-header {\n  display: grid; gap: 8px; padding: 8px 12px; background: var(--p-color-bg-surface-secondary, #f7f7f7);\n  border-bottom: 1px solid var(--p-color-border, #e3e3e3); align-items: center;\n}\n\n/* Empty State */\n.empty-state-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  text-align: center;\n  gap: 8px;\n}\n.empty-state-message {\n  max-width: 420px;\n  margin-top: 4px;\n}\n.empty-state-action {\n  margin-top: 12px;\n}\n/* EmptyState shared component icon */\n.es-icon {\n  font-size: 52px;\n  line-height: 1;\n  margin-bottom: 4px;\n  filter: grayscale(0.1);\n}\n\n/* Utility Classes */\n.w-100 { width: 100%; }\n.max-w-400 { max-width: 400px; }\n.flex-center { display: flex; align-items: center; justify-content: center; }\n.h-100vh { height: 100vh; }\n.tab-container { display: flex; flex: 1; }\n.tab-new-button-container { padding-right: 10px; }\n\n/* Old styles that might be unused now, but kept for now */\n/* List-structure skeleton for listing pages */\n.list-skeleton-wrapper {\n  width: 100%;\n}\n.list-skeleton-row {\n  background: var(--p-color-bg-surface, #fff);\n}\n\n/* Skeleton / Shimmer Loader Styles */\n.shimmer-loader {\n  position: relative;\n  overflow: hidden;\n  background: linear-gradient(\n    90deg,\n    #e1e3e5 0%,\n    #e1e3e5 40%,\n    rgba(255, 255, 255, 0.6) 50%,\n    #e1e3e5 60%,\n    #e1e3e5 100%\n  );\n  background-size: 200% 100%;\n  animation: shimmer-slide 1.5s ease-in-out infinite;\n  border-radius: 4px;\n}\n.shimmer-rounded { border-radius: 4px; } /* For rounded shimmers */\n@keyframes shimmer-slide { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }\n\n/* Spacing utilities */\n.gap-small-100 { gap: 0.5rem; }\n.gap-small-200 { gap: 0.75rem; }\n.gap-base { gap: 1rem; }\n.gap-large { gap: 1.5rem; }\n\n/* ── Info tooltip (hover bubble next to “i”) ───────────────────────────────── */\n.info-tooltip {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: help;\n  max-width: 100%;\n}\n\n.info-tooltip-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background-color: #8c9196;\n  color: #ffffff;\n  font-size: 10px;\n  font-weight: 700;\n  font-style: normal;\n  line-height: 1;\n  user-select: none;\n  flex-shrink: 0;\n}\n\n.info-tooltip-bubble {\n  visibility: hidden;\n  opacity: 0;\n  position: absolute;\n  bottom: calc(100% + 10px);\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #202223;\n  color: #ffffff;\n  font-size: 12px;\n  line-height: 1.4;\n  padding: 8px 12px;\n  border-radius: 6px;\n  white-space: normal;\n  width: max-content;\n  max-width: 280px;\n  min-width: 80px;\n  text-align: center;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  z-index: 1000;\n  pointer-events: none;\n  transition: opacity 0.2s ease, visibility 0.2s ease, transform 0.2s ease;\n}\n\n.info-tooltip-bubble::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 6px solid transparent;\n  border-top-color: #202223;\n}\n\n.info-tooltip:hover .info-tooltip-bubble,\n.info-tooltip:focus-within .info-tooltip-bubble {\n  visibility: visible;\n  opacity: 1;\n  transform: translateX(-50%) translateY(-2px);\n}\n\n/* ── Job activity feed ──────────────────────────────────────────────────────── */\n.job-activity-feed {\n  max-height: 320px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.job-activity-feed-header {\n  padding: 8px 12px;\n  border-bottom: 1px solid var(--p-color-border-subdued, #e1e3e5);\n  flex-shrink: 0;\n}\n\n.job-activity-feed-scroll {\n  overflow-y: auto;\n  padding: 12px;\n  flex: 1;\n}\n\n/* ── Job activity thumbnail ─────────────────────────────────────────────────── */\n.job-item-thumbnail {\n  width: 32px;\n  height: 32px;\n  border-radius: 4px;\n  flex-shrink: 0;\n}\n\n/* ── Progress bar cancelled state ───────────────────────────────────────────── */\n.progress-bar-fill.progress-cancelled {\n  background-color: #d82c0d;\n}\n\n/* ── Shimmer sizes ──────────────────────────────────────────────────────────── */\n.shimmer-loader-tall { height: 200px; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
